<template>
  <div class="bottom">
    <ul>
      <li>© {{info.fullName}}版权所有</li>
      <li>
        <img src="@/assets/common/img/batb.png" style=""/>&nbsp;
        <a target="_blank"
           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51011402000502">
<!--          川公网安备 {{ info.pcCode }}号-->
        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a target="_blank" href="https://beian.miit.gov.cn/">{{ info.icpCode }}</a>
      </li>
      <li>

      </li>
    </ul>
  </div>
</template>

<script>
import { INFO } from '@/util/const';

export default {
  name: 'Bottom',
  data() {
    return {
      info: INFO,
    };
  },
};
</script>

<style scoped>

</style>
